import { randomId } from '~~/shared/random'

interface Modal {
  component: Component
  props?: Record<string, any>
  id: string
}

export function useModal() {
  const modals = useState('modals', () => ref<Modal[]>([]))

  const open = (component: Component, props?: Record<string, any>, id?: string) => {
    if (!id) {
      id = randomId()
    }

    function closeModal() {
      modals.value = modals.value.filter(modal => modal.id !== id)
    }

    modals.value.push({
      component,
      props: { ...props, closeModal },
      id,
    })

    return {
      closeModal,
    }
  }

  // Remove all modals
  const closeAll = () => {
    modals.value = []
  }

  const closeById = (id: string) => {
    modals.value = modals.value.filter(modal => modal.id !== id)
  }

  const closeByComponent = (component: Component) => {
    modals.value = modals.value.filter(modal => modal.component !== component)
  }

  return {
    modals, open, closeAll, closeById, closeByComponent,
  }
}
